import '@shared/style/normalize.css';
import '@shared/style/global.css';
import { I18nProvider } from './providers/i18n/i18n-provider';
import { ReduxProvider } from './providers/redux/redux-provider';
import { ErrorBoundary } from '@shared/ui/error-boundary/error-boundary';
import { ErrorPage } from '@pages/public/error';
import { SocketProvider } from './providers/socket-provider/socket-provider';
import { AppContentProvider } from './providers/app-content/app-content-provider';

function App() {
  return (
    <ErrorBoundary fallback={<ErrorPage />}>
      <I18nProvider>
        <ReduxProvider>
          <SocketProvider>
            <AppContentProvider />
          </SocketProvider>
        </ReduxProvider>
      </I18nProvider>
    </ErrorBoundary>
  );
}

export default App;
